export enum Permission {
  Allow = 'Allow',
  Denied = 'Denied',
  Mine = 'Mine',
}
